import languageOptions from './languages';

export default [
    {
    name: 'languages',
    title: 'Languages',
    slug: 'languages',
    shortName: 'Languages',
    fields: [
      {
        name: 'languages',
        type: 'multi-select',
        label: '1.1. Website Languages',
        options: languageOptions,
      },
      {
        name: 'data_labels',
        type: 'multi-file',
        label: '1.2. Data Labels to Translate',
      },
      {
        name: 'error_messages',
        type: 'multi-file',
        label: '1.3. Error Messages to Translate',
      },
      {
        name: 'translated_labels',
        type: 'translated-field-file',
        label: '1.4. Translated Labels',
        labelWhenEmpty: 'Select a Language'
      },
    ],
  },
  {
    name: 'docs',
    title: 'Documents',
    slug: 'documents',
    shortName: 'Documents',
    fields: [
      {
        name: 'website_regulations',
        type: 'translated-field-file',
        label: '2.1. Website Regulations',
        labelWhenEmpty: 'No Language Selected',
        sample: '/samples/sampleregulations.pdf'
      },
      {
        name: 'products',
        type: 'multi-file',
        label: '2.2. Product List',
        sample: '/samples/product_list.docx'
      },
      {
        name: 'prices',
        type: 'multi-file',
        label: '2.3. Pricing List',
        sample: '/samples/pricing_list.xlsx'
      },
      {
        name: 'policy',
        type: 'translated-field-file',
        label: '2.4. Policy Wording',
        sample: '/samples/policy_wording.pdf'
      },
      {
        name: 'tnc',
        type: 'translated-field-file',
        label: '2.5. Terms and Conditions',
        sample: '/samples/tnc.doc'
      },
      {
        name: 'rules',
        type: 'multi-file',
        label: '2.6. Quote Rules',
      },
      {
        name: 'compliance_regulations',
        type: 'multi-file',
        label: '2.7. Compliance Regulations',
      },
      {
        name: 'policy_numbering',
        type: 'text',
        label: '2.8. Policy Numbering'
      },
      {
        name: 'email_template',
        type: 'translated-field-file',
        label: '2.9. Email Template',
        sample: '/samples/emailtemplate.docx'
      },
      {
        name: 'nb_attachments',
        type: 'number',
        label: '2.10. Number of Attachments',
        defaultValue: 0,
      },
      {
        name: 'email_attachments',
        type: 'translated-field-file',
        label: '2.11. Fulfillment Email Attachments',
        defaultValue: 0,
      },
      {
        name: 'dual_language',
        type: 'select',
        label: '2.12. Dual Language Email',
        defaultValue: 'single',
        options: {
          single: 'Combine Languages',
          dual: 'Per Language',
        },
      },
      {
        name: 'email_sender_address',
        type: 'multi-text',
        label: '2.13. Email Sender Address',
        placeholder: 'Add email address',
      },
      {
        name: 'email_sender_name',
        type: 'text',
        label: '2.14. Email Sender Name',
      },
      {
        name: 'email_cc',
        type: 'multi-text',
        label: '2.15. Email Copy List',
        placeholder: 'Add email address',
        noResultsText: 'Type an email address',
        addText: 'Add \':label\'',
      },
      {
        name: 'email_bcc',
        type: 'multi-text',
        label: '2.16. Email Background Copy List',
        placeholder: 'Add email address',
        noResultsText: 'Type an email address',
        addText: 'Add \':label\'',
      },
      {
        name: 'email_subject',
        type: 'translated-field-text',
        label: '2.17. Email Subject',
      },
      {
        name: 'email_support',
        type: 'select',
        label: '2.18. Email Support',
        defaultValue: 'vendor',
        options: {
          vendor: 'Provided by Ancileo',
          client: 'Provided by Client',
        },
      },
    ],
  },
  {
    name: 'data',
    title: 'Data Exchange',
    slug: 'data-exchange',
    shortName: 'Data Ex.',
    fields: [
      {
        name: 'api_doc',
        type: 'multi-file',
        label: '3.1. Exchange API Document',
      },
      {
        name: 'protocol',
        type: 'select',
        label: '3.2. Exchange Protocol',
        options: {
          sftp: 'SFTP',
          realtimefeed: 'Real Time Feed',
        },
      },
      {
        name: 'ga',
        type: 'text',
        label: '3.3. Google Analytics',
      },
      {
        name: 'test_credentials',
        type: 'text',
        label: '3.4. Test Credentials',
      },
    ],
  },
  {
    name: 'reporting',
    title: 'Financial Reporting',
    slug: 'financial-reporting',
    shortName: 'Fin. Rep.',
    fields: [
      {
        name: 'reporting_format',
        type: 'multi-file',
        label: '4.1. Reporting Format',
      },
      {
        name: 'information_template',
        type: 'multi-file',
        label: '4.2 Information Template',
      },
      {
        name: 'reporting_sample',
        type: 'multi-file',
        label: '4.3 Reporting Sample',
      },
      {
        name: 'report_receivers',
        type: 'text',
        label: '4.4 Where should reporting be sent?',
      },
      {
        name: 'reporting_schedule',
        type: 'select',
        options: {
          daily: 'Daily',
          bimonthly: 'Bi-Monthly',
          monthly: 'Monthly',
        },
        label: '4.5 Frequency report to be generated',
      },
    ],
  },
  {
    name: 'API',
    title: 'API Integration',
    slug: 'api',
    shortName: 'API',
    fields: [
      {
        name: 'booking_flow_provider',
        type: 'text',
        label: '5.1. Booking Flow Provider',
      },
      {
        name: 'test_ip_wl',
        type: 'multi-text',
        noResultsText: 'Type an IP Address',
        addText: 'Add \':label\'',
        label: '5.2. Test IP Whitelist',
        placeholder: 'Type an IP Address',
      },
      {
        name: 'prod_ip_wl',
        type: 'multi-text',
        noResultsText: 'Type an IP Address',
        addText: 'Add \':label\'',
        label: '5.3. Production IP Whitelist',
        placeholder: 'Type an IP Address',
      },
      {
        name: 'test_credentials',
        type: 'multi-file',
        label: '5.4. API Test Credentials',
      },
      {
        name: 'api_doc',
        type: 'multi-file',
        label: '5.5. API Documentation',
      },
      {
        name: 'payment_process',
        type: 'text',
        label: '5.6. How will the payment be processed (not captured by API)?',
      },
      {
        name: 'ip_design',
        type: 'multi-file',
        label: '5.7. Selected integrated path design to provider',
        sample: '/samples/sample_ip_design.png',
      },
      {
        name: 'implementation_crosscheck',
        type: 'text',
        label: '5.8. Crosscheck API implementation',
      }
    ],
  },
  {
    name: 'cancellation',
    title: 'Cancellation and Edit',
    slug: 'cancel-and-edit',
    shortName: 'Can. & Edit',
    fields: [
      {
        name: 'cancel_required',
        type: 'select',
        label: '6.1. Cancellation and Edit Function Required',
        options: {
          cancel: 'Cancel Only',
          edit: 'Edit Only',
          required: 'Both Cancellation and Edit',
          notrequired: 'Not Required'

        },
      },
      {
        name: 'preferred',
        type: 'select',
        label: '6.2. Preferred Process',
        options: {
          reissue: 'Cancel policy and issue new policy',
          editpremium: 'Charge for (+) or (-) in premium',
        },
      },
      {
        name: 'business_rules',
        type: 'multi-file',
        label: '6.3. Business Rules Applicable',
      },
      {
        name: 'specific',
        type: 'text',
        label: '6.4. Specific User Requirements',
      },
      {
        name: 'email_template',
        type: 'multi-file',
        label: '6.5. Email Template',
      },
      {
        name: 'nb_attachments',
        type: 'number',
        label: '6.6. Number of Attachments',
        defaultValue:0
      },
      {
        name: 'email_attachments',
        type: 'multi-file',
        label: '6.7. Email Attachments',
      },
    ],
  },
  {
    name: 'design',
    title: 'Design Review',
    slug: 'design-review',
    shortName: 'Design Review',
    fields: [
      {
        name: 'branding_required',
        type: 'select',
        label: '7.1. Co-Branding Required',
        defaultValue: 'notrequired',
        options: {
          required: 'Yes',
          notrequired: 'No',
        },
      },
      {
        name: 'guidelines',
        type: 'multi-file',
        label: '7.2. Pantone Scheme/Font/Logo Guidelines',
      },
      {
        name: 'first_draft',
        type: 'multi-file',
        label: '7.3. First Draft of Designs',
      },
      {
        name: 'first_review',
        type: 'multi-file',
        label: '7.4. Review of First Draft of Designs',
      },
      {
        name: 'amend_design1',
        type: 'multi-file',
        label: '7.5. Amended Designs (First Round)',
      },
      {
        name: 'review_design1',
        type: 'multi-file',
        label: '7.6. Design Review (First Round)',
      },
      {
        name: 'amend_design2',
        type: 'multi-file',
        label: '7.7. Amended Designs (Second Round)',
      },
      {
        name: 'review_design2',
        type: 'multi-file',
        label: '7.8. Design Review (Second Round)',
      },
      {
        name: 'sign_off',
        type: 'text',
        label: '7.9. Design Sign-Off',
      },
    ],
  },
];


// WEBPACK FOOTER //
// ./src/lib/api.definition.js